/* eslint-disable react/no-children-prop */
import cn from 'classnames';
import React, { ReactNode } from 'react';

import { Content } from '../common/content';
import { Header } from '../Header';
interface LayoutProps {
  [key: string]: unknown;
  className?: string;
  children: ReactNode;
}

export function Layout(props: LayoutProps) {
  const { className, children } = props;

  return (
    <div className={cn(className, 'box-border')}>
      <Header />
      <Content children={children} />
    </div>
  );
}
